var toValueString = require('./toValueString')

var helperStringRepeat = require('./helperStringRepeat')

/**
  * 将字符串重复 n 次
  *
  * @param {String} str 字符串
  * @param {Number} count 次数
  * @return {String}
  */
function repeat (str, count) {
  return helperStringRepeat(toValueString(str), count)
}

module.exports = repeat



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/repeat.js
// module id = 547
// module chunks = 98